import i from"@emotion/styled";import{setColor as r,setRadius as a,setFontWeight as n,setFontSize as l}from"../../utils/generateStyles.js";var d=Object.defineProperty,p=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,b=Object.prototype.propertyIsEnumerable,s=(e,t,o)=>t in e?d(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,u=(e,t)=>{for(var o in t||(t={}))c.call(t,o)&&s(e,o,t[o]);if(p)for(var o of p(t))b.call(t,o)&&s(e,o,t[o]);return e};const y=i.div`
  label: select;
  display: inline-block;
  width: 100%;
  position: relative;
  ${e=>e.disabled&&{cursor:"default",pointerEvents:"none !important",opacity:"0.9"}}
`,m=i.div`
  label: select-input;
  border: 1px solid;
  padding: 12px 16px;
  cursor: pointer;
  ${()=>r("gray-90","borderColor")}
  ${()=>r("white","backgroundColor")}
  ${()=>a("md")}
  &::after {
    content: '';
    position: absolute;
    left: 15px;
    top: 22px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent;
    border-top-color: #323232;
  }
  ${e=>e.isOpen&&{"&::after":{top:"16px",borderTopColor:"transparent",borderBottomColor:"#323232"}}}
`,g=i.span`
  label: select-input-placeholder;
  ${()=>n("regular")}
  ${()=>l("xs")}
  ${()=>r("gray-100","color")}
`,x=i.span`
  label: select-input-text;
  ${()=>n("medium")}
  ${()=>l("sm")}
  ${()=>r("gray-100","color")}
`,f=i.li`
  label: select-search-root;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: none;
  border-bottom: 1px solid;
  padding-right: 12px;
  padding-left: 12px;
  ${()=>r("gray-10","borderColor")}
`,h=i.input`
  label: select-search-input;
  width: 100%;
  border: none;
  outline: none;
  padding: 12px;
  font-weight: 400;
  ${()=>r("gray-100","color")}
`,$=i.ul`
  label: select-list-roots;
  @keyframes visibilityAnimation {
    from {
      opacity: 0.0001;
    }
    to {
      opacity: 1;
    }
  }
  margin: 0;
  margin-top: 8px;
  padding: 0;
  position: absolute;
  width: 100%;
  overflow: auto;
  box-shadow: 0px 8px 10px -3px rgba(0, 0, 0, 0.1),
    0px 3px 8px 1px rgba(0, 0, 0, 0.15);
  animation-name: visibilityAnimation;
  animation-duration: 0.15s;
  max-height: 270px;
  z-index: 9999;
  ${()=>r("white","backgroundColor")}
  ${()=>a("lg")}
  ${e=>e.isOpenFromBottom&&{bottom:"64px"}};
  ${e=>!e.isOpen&&{display:"none"}}
`,S=i.li`
  label: select-list-items;
  cursor: pointer;
  padding: 12px 16px;
  list-style-type: none;
  font-weight: 400;
  transition-property: background-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  ${()=>r("gray-140","color")}
  ${()=>l("sm")};
  &:hover {
    ${()=>r("gray-10","backgroundColor")}
  }
  ${e=>e.isSelected&&u({display:"flex",alignItems:"center",position:"relative",justifyContent:"space-between"},r("blue-00","backgroundColor"))};
  ${e=>e.isDisabled&&{cursor:"default",pointerEvents:"none !important",opacity:"0.5"}};
`;export{g as SelectInputPlaceholderStyled,m as SelectInputStyled,x as SelectInputTextStyled,S as SelectListItemStyled,$ as SelectListRootStyled,h as SelectSearchInputStyled,f as SelectSearchRootStyled,y as SelectStyled};
